import React from "react"
import { EventsItem } from "./render-evenements-styled"
import { eventsItem } from "../agenda.module.scss"
import PropTypes from "prop-types"
import EvenementContent from "../EvenementContent/evenement-content"
import EditButton from "../../../EditButton/edit-button"

const RenderEvenements = ({ eventsData }) => {
  return (
    <>
      {eventsData.map(({ node }) => (
        <EventsItem
          key={node.drupal_id}
          className={eventsItem}
          role={"listitem"}
        >
          <EditButton link={"/node/" + node.drupal_internal__nid + "/edit"} />
          <EvenementContent evenement={node} />
        </EventsItem>
      ))}
    </>
  )
}

RenderEvenements.propTypes = {
  eventsData: PropTypes.array.isRequired,
}

export default RenderEvenements
